import { environment } from '@factorin/container.macro';
import React, { useEffect } from 'react';

import { useDispatch } from 'Modules/core/redux';
import { useTranslation } from 'Modules/core/i18n';

import { environmentActions } from '../state/actions';
import { LoginErrorWindow } from '../components/LoginErrorWindow';
import { ApplicationInitializer } from '../components/ApplicationInitialization';
import { useEnvironment } from '../state/utils';


export const createError = type => ({ message }) => {
    const { t } = useTranslation('system');
    return (
        <LoginErrorWindow>
            {message}
            {message && <br />}
            {t(type)}
        </LoginErrorWindow>
    );
};

export const ForbiddenError = createError('forbiddenError');
export const UserNotFoundError = createError('userNotFound');
export const UnknownError = createError('unknownError');

export const InitializationErrorPages = ({ Next }) => {
    const error = useEnvironment('error');
    if (!error)
        return <Next />;

    const { type, message } = error;
    const Error = environment.initializationErrors[type] || UnknownError;

    return <Error message={message} />;
};

export const FactorinInitializer = ({ Next }) => {
    const initialized = useEnvironment('initialized');
    const dispatch = useDispatch();
    useEffect(() => {
        if (!initialized)
            dispatch(environmentActions.initialize());
    }, [initialized, dispatch]);
    return initialized ? <Next /> : <ApplicationInitializer />;
};
